import { ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

export const CTA = () => {
  return (
    <section data-testid="cta-section" className="py-24 md:py-32 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-slate-900 rounded-3xl px-8 py-16 md:px-16 md:py-20 overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-80 h-80 bg-emerald-500/10 rounded-full blur-[100px]" />
          <div className="absolute bottom-0 left-0 w-60 h-60 bg-emerald-500/10 rounded-full blur-[80px]" />

          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white tracking-tight mb-5">
              Empiece hoy. Transforme su practica.
            </h2>
            <p className="text-base md:text-lg text-slate-400 leading-relaxed mb-10">
              Unase a los fisioterapeutas que ya estan dando continuidad real a sus tratamientos. 14 dias gratis, sin tarjeta de credito.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                data-testid="cta-start-button"
                className="bg-emerald-500 hover:bg-emerald-400 text-white font-semibold px-8 py-6 text-base rounded-full shadow-lg shadow-emerald-500/30 hover:shadow-emerald-500/50 transition-shadow duration-200 group"
              >
                Empezar prueba gratis
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
              </Button>
              <Button
                data-testid="cta-demo-button"
                variant="outline"
                className="border-slate-600 hover:border-slate-500 text-slate-300 hover:text-white font-medium px-8 py-6 text-base rounded-full hover:bg-slate-800 transition-colors duration-200"
              >
                Agendar demostracion
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
